Service = App.loadClass 'core::Angular/Service'

class exports.SetPasswordService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    isCargillUser: (authenticationCode) =>
        return @http.get 'backend/session-mgmt/company-internal-name-by-auth-code',
            params: {
                authenticationCode
            }
        .then (response) =>
            # determine if the company internal name is cargill
            return response.data is 'Cargill'

    checkAuthCode: (params) =>
        return @http.post 'backend/session-mgmt/check-auth-code-to-set-password',
            auth_code: params.authentication_code
            is_password_reset: params.is_password_reset
            client: params.target

    save: (params) =>
        return @http.post 'backend/session-mgmt/update-password',
            client: params.client
            policy: params.policy
            auth_code: params.auth_code
            auth_verify: params.auth_verify
            password: params.password
            password_confirm: params.password_confirm
            email: params.email
            data_token: params.data_token
